import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
  children?: React.ReactNode;
}

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, required = false, children, ...props }, ref) => {
    const { colors, theme } = useTheme();
    const isDark = theme === 'dark';

    return (
      <label
        ref={ref}
        className={cn(`block text-sm font-semibold ${colors.text} mb-2`, className)}
        {...props}
      >
        {children}
        {required && (
          <span className={cn('ml-1', isDark ? 'text-red-400' : 'text-red-600')}>*</span>
        )}
      </label>
    );
  }
);

Label.displayName = 'Label';

export { Label };

